import React from 'react'
import { SwiperSlide } from 'swiper/react'
import { string, shape, array, number, object, bool } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { urlWithTrack } from '../../helpers/common'
import { sendClickEventToInsights } from '../../utils/insights'
import { NUMERAL, ZERO, EMPTY_ARRAY } from '../../utils/constants'
import Image from '../ui/image/Image'
import AdSwiper from '../ui/ad-swiper/AdSwiper'
import AdLink from '../ui/ad-link/AdLink'
import SaveButton from '../ui/button/SaveButton'
import Insights from './Insights'
import { productMessages as messages } from './messages'

const Product = ({
  manufacturer,
  categories,
  title,
  url = NUMERAL,
  caracteristics,
  bimsFilesCount = ZERO,
  images = EMPTY_ARRAY,
  insights,
  type,
  bim,
  country = EMPTY_ARRAY,
  gridView
}) => {
  const handleLinkClick = () => {
    sendClickEventToInsights(insights.category, insights.label, insights.value, insights.version)
  }
  const trackedUrl = urlWithTrack(url, type)
  const saveButtonImage = images.length > 0 ? images[0].url_medium : ''

  return (
    <Insights {...insights}>
      <div className='object-container project-object'>
        {/* Image */}
        <div className='object-image project-object__image-container'>
          {bim && <span className='products__bim-label'>BIM</span>}
          {images.length > 1 ? (
            <AdSwiper>
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <div className='project-object__image-wrapper'>
                    <AdLink href={trackedUrl} onClick={handleLinkClick}>
                      <Image data-src={image.url_medium} data-object-fit='cover' />
                    </AdLink>
                  </div>
                </SwiperSlide>
              ))}
            </AdSwiper>
          ) : (
            <div className='project-object__image-wrapper'>
              <AdLink href={trackedUrl} onClick={handleLinkClick}>
                <Image src={images[0].url_medium} data-object-fit='cover' />
              </AdLink>
            </div>
          )}
          <SaveButton title={title} image={saveButtonImage} url={url} gridView={gridView} insights={insights} />
        </div>

        {/* title */}
        <h3 className='object-title project-object__title afd-title-big'>
          <AdLink className='afd-title--black-link' href={trackedUrl} onClick={handleLinkClick}>
            {title}
          </AdLink>
        </h3>

        {/* metadata */}
        <ul className='object-metadata project-object__metadata'>
          <li>
            <FormattedMessage {...messages.product} />
          </li>
        </ul>

        {/* content */}
        <div className='object-content'>
          {/* manufacturer */}
          {!!manufacturer && (
            <p className='project-object__content'>
              <span className='object-content__bold'>
                <FormattedMessage {...messages.manufacturer} />
                {': '}
              </span>
              <AdLink href={urlWithTrack(manufacturer.url, type)}>{manufacturer.name}</AdLink>
            </p>
          )}
          {/* Use */}
          {categories.length > 0 && (
            <p className='project-object__content'>
              <span className='object-content__bold'>
                <FormattedMessage {...messages.use} />
                {': '}
              </span>
              {categories.map((item, index) => (
                <AdLink key={index} href={urlWithTrack(item.url, type)}>
                  {!!index && ', '}
                  {item.name}
                </AdLink>
              ))}
            </p>
          )}
          {/* Caracteristics */}
          {!!caracteristics && (
            <p className='project-object__content'>
              <span className='object-content__bold'>
                <FormattedMessage {...messages.characteristics} />
                {': '}
              </span>
              {caracteristics}
            </p>
          )}
          {/* Country */}
          {country.length > 0 && (
            <p className='project-object__content'>
              <span className='object-content__bold'>
                <FormattedMessage {...messages.country} />
                {': '}
              </span>
              {country}
            </p>
          )}

          {/* BIM Files */}
          {!!bimsFilesCount && (
            <p className='project-object__content'>
              <span className='object-content__bold'>
                <FormattedMessage {...messages.bimObjects} />
                {': '}
              </span>
              <AdLink href={urlWithTrack(url + '/bim-files', type)}>{bimsFilesCount}</AdLink>
            </p>
          )}
        </div>
      </div>
    </Insights>
  )
}

Product.propTypes = {
  bimsFilesCount: number,
  bim: bool,
  caracteristics: string,
  categories: array,
  images: array,
  manufaturer: shape({
    name: string,
    url: string
  }),
  title: string,
  url: string,
  manufacturer: object,
  insights: object,
  type: string,
  country: array,
  gridView: bool
}

export default React.memo(Product)
